import React from 'react';
import './App.css';

function Footer() {
  return <footer className="App-footer"></footer>;
}

export default Footer;
